import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import CheckMOT from './checkMOT.tsx';
import Home from './home.tsx';

const router = createBrowserRouter([
  {
    path: '/reg/:registration',
    element: <CheckMOT />,
  },
  {
    path: '/',
    element: <Home />
  },
]);

function App() {
  return (
    <CookiesProvider>
      <RouterProvider router={router} />
    </CookiesProvider>
  );
}

export default App;